<template>
    <el-card class="box-card">
        <!-- 表单只有一个文本框的时候，按回车会自动submit表单，需要禁用sunmit -->
        <el-form
            ref="searchform"
            :inline="true"
            :model="form"
            @submit.native.prevent
            size="medium"
        >
            <el-form-item label="状态" prop="status">
                <el-select
                    v-model="form.status"
                    placeholder="选择状态"
                    class="statusc"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="status in [{id:0,name:'禁用'},{id:1,name:'正常'}]"
                        :key="status.id"
                        :label="status.name"
                        :value="status.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属客户" prop="with_client_id">
                <el-select
                    v-model="form.with_client_id"
                    placeholder="选择客户"
                    class="clientc"
                    filterable
                    clearable
                >
                    <el-option
                        v-for="client in AllClient"
                        :key="client.id"
                        :label="client.name"
                        :value="client.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="产品名称" prop="name">
                <el-input
                    v-model="form.name"
                    placeholder="产品名称搜索"
                    @keyup.enter.native="search()"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain @click="search">搜索</el-button>
                <el-button type="warning" plain @click="resetbtn('searchform')"
                    >重置</el-button
                >
            </el-form-item>
            <el-button
                v-if="$_has(add_auth)"
                type="success"
                plain
                round
                @click="addTeam"
                class="temp_add"
                size="medium"
                >添加产品</el-button
            >
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'ProductSearchBarComponent',
    data() {
        return {
            fdialogFormVisible: false,
            form: {
                name: '',
                with_client_id: '',
                status:'',
                page: 1,
            },
        }
    },
    computed: {},
    methods: {
        search() {
            this.$emit('search', this.form)
        },
        resetbtn(f) {
            this.$refs[f].resetFields()
        },
        addTeam() {
            this.$emit('addTeam')
        },
    },
    filters: {},
    props: {
        add_auth: String,
        AllClient: Array
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {},
}
</script>

<style>
.temp_add {
    float: right;
    margin-bottom: 10px;
}
</style>